import axios from '@fs/zion-axios'

const BASE_RELATIONSHIP_PATH = '/service/dmc/relationships'

export async function getRelationship(relationshipType, relationshipId) {
  const response = await axios.get(`${BASE_RELATIONSHIP_PATH}/${relationshipType}/${relationshipId}`)
  return response
}

export async function postRelationshipFact(relationshipType, relationshipId, factConclusion) {
  const response = await axios.post(
    `${BASE_RELATIONSHIP_PATH}/${relationshipType}/${relationshipId}/facts`,
    factConclusion
  )
  return response
}

export async function putRelationshipFact(relationshipType, relationshipId, factConclusion, changeMessage) {
  const response = await axios({
    method: 'put',
    url: `${BASE_RELATIONSHIP_PATH}/${relationshipType}/${relationshipId}/facts/${factConclusion.conclusionId}`,
    data: factConclusion,
    headers: {
      'X-Reason': changeMessage,
    },
  })
  return response
}

export async function deleteRelationshipFact(relationshipType, relationshipId, factConclusionId, changeMessage) {
  const response = await axios({
    method: 'delete',
    url: `${BASE_RELATIONSHIP_PATH}/${relationshipType}/${relationshipId}/facts/${factConclusionId}`,
    headers: {
      'X-Reason': changeMessage,
    },
  })
  return response
}

export async function getRelationshipChanges(relationshipType, relationshipId, fromChangeId) {
  const fromString = fromChangeId ? `?fromChangeId=${fromChangeId}` : ''
  const response = axios.get(`${BASE_RELATIONSHIP_PATH}/${relationshipType}/${relationshipId}/changes${fromString}`)
  return response
}

export function editParentChildRelationship(relationshipId, changeMessage, parent1Id, parent2Id, childId) {
  return axios.put(`${BASE_RELATIONSHIP_PATH}/parentchild/${relationshipId}/update`, {
    parent1Id,
    parent2Id,
    childId,
    attribution: {
      changeMessage,
    },
  })
}

export function switchPersons(relationshipType, relationshipId, justification, person1Id, person2Id) {
  return axios.put(`${BASE_RELATIONSHIP_PATH}/${relationshipId}/switchpersons`, {
    relationshipType,
    person1Id,
    person2Id,
    justification,
  })
}
